// 加载核心加密库
import CryptoJS from 'crypto-js'

// js代码不要暴漏在外面，不然key会被拿到
const publicKey = '3346443930383143333944363733443838463431413339454138413144363444'
const aseKey = CryptoJS.enc.Hex.parse(publicKey)
const iv= CryptoJS.enc.Hex.parse("44373434333341463739373542384643")

export function encrypt(message) {
  const encrypted = CryptoJS.AES.encrypt(message, aseKey, {
    iv:iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString().toUpperCase()
}

export function decrypt(message) {
  const plaintext = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(message), aseKey, {
    iv:iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(plaintext)
}

